import { createUseStyles } from '@pe-libs/react-components/build/theme';

const useStyles = createUseStyles('pe-register', (theme) => ({
  form: {
    textAlign: 'center',
    marginBottom: '2.286em',
  },

  inputEmail: {
    marginBottom: '0.857em',
  },

  inputSubmit: {
    textTransform: 'uppercase',
  },

  termsAndConditions: {
    marginBottom: '3.429em',
  },

  nolinkreceived: {
    marginBottom: '0.3em',
    cursor: 'pointer',
  },

  mistyped: {
    cursor: 'pointer',
  },

  icon: {
    fontSize: '3rem',
    color: theme.palette.grey.A200,
    marginTop: '0.8em',
    marginBottom: '1em',
  },

  semibold: {
    fontWeight: theme.typography.fontWeightSemiBold,
  },
  socialProfileContainer: {
    marginBottom: '1.5em',
  },
  socialProfileButton: {
    border: 0,
    padding: 0,
    lineHeight: 0,
    background: 'none',
    overflow: 'hidden',
    margin: '0 0.375rem',
    cursor: 'pointer',
    '@media(max-width: 385px)': {
      width: '5rem',
      '&:first-child, &:nth-child(2)': {
        marginBottom: '0.75rem',
      },
    },
  },
  socialProfileButtonContainer: {
    margin: '0.857em auto 0',
    display: 'flex',
    justifyContent: 'center',
    '@media(max-width: 385px)': {
      maxWidth: '12.5rem',
      flexWrap: 'wrap',
    },
  },
  xing: {
    display: 'inline',
    margin: '0 0.375rem',
    '@media(max-width: 385px)': {
      width: '5rem',
    },
  },
  cookieBox: {
    background: '#F5F5F5',
    padding: '3.75rem 1rem',
  },
  cookieIcon: {
    fontSize: '2rem',
    color: theme.palette.grey[500],
    paddingBottom: '1rem',
  },
  cookieCta: {
    marginTop: '1.75rem',
  },
}));

export default useStyles;
